export var DateMode={DAY_MONTH_YEAR:"day-month-year",MONTH_YEAR:"month-year"};